// src/config/constants.ts

export const MEASUREMENT_CONFIG = {
  DURATION_MS: 10000,              // 10 seconds
  TARGET_FPS: 30,
  POSE_SAMPLE_RATE: 3,             // 3 fps
  FACE_SAMPLE_RATE: 3,             // 3 fps
  SKIN_SAMPLE_RATE: 1,             // 1 fps
} as const;

export const RPPG_CONFIG = {
  ROI: {
    X_CENTER: 0.5,     // Center horizontally
    Y_CENTER: 0.25,    // 25% from top (forehead center)
    WIDTH: 0.25,       // Narrower width for better forehead focus
    HEIGHT: 0.15,      // Narrower height for better forehead focus
  },
  HR_FREQ_RANGE: [0.7, 4.0] as const,      // 42-240 bpm
  RR_FREQ_RANGE: [0.1, 0.7] as const,      // 6-42 bpm
  MIN_CONFIDENCE: 0.05,  // Lowered for development/testing (was 0.3)
} as const;

export const POSE_CONFIG = {
  MODEL_PATH: '/models/pose_landmarker_lite.task',
  MIN_DETECTION_CONFIDENCE: 0.5,
  MIN_TRACKING_CONFIDENCE: 0.5,
  SHOULDER_HIP_THRESHOLD: 0.2,    // Sitting vs standing
  BODY_ANGLE_THRESHOLD: 45,        // Collapsed detection
} as const;

export const FACE_CONFIG = {
  MODEL_PATH: '/models/face_landmarker.task',
  MIN_DETECTION_CONFIDENCE: 0.5,
  EYE_LANDMARKS: {
    LEFT: [33, 133, 160, 144, 159, 145],
    RIGHT: [263, 362, 385, 380, 374, 387],
  },
  PAIN_THRESHOLDS: [0.25, 0.5, 0.75], // For 0-3 scoring
} as const;

export const API_CONFIG = {
  TIMEOUT_MS: 30000,
  MAX_RETRIES: 3,
  RETRY_DELAY_BASE_MS: 1000,
} as const;

export const ERROR_MESSAGES = {
  cameraPermissionDenied: 'Please allow camera access in Settings',
  cameraNotFound: 'No camera found on this device',
  cameraInitFailed: 'Failed to start camera',
  networkError: 'Network error. Please check connection and retry.',
  apiAuthFailed: 'Authentication failed. Contact administrator.',
  processingFailed: 'Processing failed. Please try again.',
  invalidData: 'Invalid data format. Please retake measurement.',
} as const;
